import  uniqWith  from 'lodash/uniqWith';
import  isEqual  from 'lodash/isEqual';
import { isInt } from './utils';
import { removeComma } from './stringutils';
import  sortBy  from 'lodash/sortBy';
import  forEach  from 'lodash/forEach';
import  filter  from 'lodash/filter';
import  orderBy  from 'lodash/orderBy';
import  unionBy  from 'lodash/unionBy';


export function continentFilter(continentArr, productResultsArr){
  // Calculate continent numbers
  // 1. Create new object with continent names and zero values
  // 2. Increment values based on the continents linked to the products
  // 3. Return sorted by 'priority'
  let continentsArray = [];
  for(let i = 0; i < continentArr.length; i++){
      continentsArray.push({
        name:continentArr[i].fields.name,
        priority:continentArr[i].fields.order,
        count:0
      });
  }

  for(let j = 0; j < productResultsArr.length; j++){
      for(let jj = 0; jj < continentsArray.length; jj++){
        if(productResultsArr[j].fields.categoryWhere.fields.name === continentsArray[jj].name){
          continentsArray[jj].count++;
        }
      }
  }

  const filterContinent = continentsArray.filter(item => item.name !== "USA & Canada");
  return sortBy(filterContinent, ['priority']);
}

export function travelStyleFilter(categoryArr, productResultsArr){

  // Calculate travel style numbers
  // 1. Create new object with travel style names and zero values
  // 2. Increment values based on the travel style linked to the products
  // 3. Return sorted by 'priority'
  let travelStyleArray = [];
  for(let ii = 0; ii < categoryArr.length; ii++){
    travelStyleArray.push({
      name:categoryArr[ii].fields.name,
      priority:categoryArr[ii].fields.order,
      count:0
    });
  }

  for(let k = 0; k < productResultsArr.length; k++){
      for(let kk = 0; kk < travelStyleArray.length; kk++){
        if(productResultsArr[k].fields.category.fields.name === travelStyleArray[kk].name){
          travelStyleArray[kk].count++;
        }
      }
  }

  return sortBy(travelStyleArray, ['priority'] );
}

export function countryFilter(productResultsArr){
  //Calculate country numbers
  //1. Create a new object with country names and zero values (looks in nested arrays)
  //2. Increment unique values based on country names
  //3. Return countries with numberes and modify country name
  let countriesArray = [];
  for(let h = 0; h < productResultsArr.length; h++){
    for(let h2 = 0; h2 < productResultsArr[h].fields.countries.length; h2++){
      countriesArray.push({
        name:productResultsArr[h].fields.countries[h2].fields.name,
        count:0
      });
    }
  }

  let uniqueCountries = uniqWith(countriesArray, isEqual);
  for(let hh = 0; hh < productResultsArr.length; hh++){
      for(let hhh = 0; hhh < productResultsArr[hh].fields.countries.length; hhh++){
          for(let hhhh = 0; hhhh < uniqueCountries.length; hhhh++){
            if(productResultsArr[hh].fields.countries[hhh].fields.name === uniqueCountries[hhhh].name){
              uniqueCountries[hhhh].count++;
            }
          }
      }
   }

  let UpdateNameArr = forEach(uniqueCountries, function(value, key) { if(value.name === "Czechia (Czech Republic)") value.name = "Czechia"});

  return orderBy(UpdateNameArr,['name'], ['asc']);
}

export function tmsProductsFilter(tmsProducts, productResults, currencyMask){
    // Append Products object with TMS Object
    // Add price / discounts / currency information / departure months
    let tempObject1 = {
      prices_from:{
        adult: "0.00",
        student: "0.00"
      },
      discount_featured:{
        discount:"0.00",
        discount_percentage:"0",
        price_new:"0.00"
      },
      departure_months:{
        [new Date().getFullYear()]:[],
        [new Date().getFullYear()+1]:[]
      }
    }

    for (let p = 0; p < productResults.length; p++){
      productResults[p].fields.currency_mask = currencyMask;
      productResults[p].fields.productsTMS = tempObject1;

      for (let pp = 0; pp < tmsProducts.length; pp++){
        if(productResults[p].fields.tourId === tmsProducts[pp].tour_id){
          var tempObject2 = {
            prices_from:{
              adult: (tmsProducts[pp].prices_from.adult == null) ? "0.00" : tmsProducts[pp].prices_from.adult,
              student: (tmsProducts[pp].prices_from.student == null) ? "0.00" : tmsProducts[pp].prices_from.student,
              adult_display_price:(tmsProducts[pp].prices_from.adult == null) ? "0.00" : removeComma(tmsProducts[pp].prices_from.adult),
              student_dislay_price: (tmsProducts[pp].prices_from.student == null) ? "0.00" : removeComma(tmsProducts[pp].prices_from.student),
              adult_base_price:(tmsProducts[pp].prices_from.adult == null) ? 0 : Math.floor(removeComma(tmsProducts[pp].prices_from.adult)),
            },
            discount_featured:{
              discount: (tmsProducts[pp].discount_featured.discount == null) ? "0.00" : tmsProducts[pp].discount_featured.discount,
              discount_percentage: (tmsProducts[pp].discount_featured.discount_percentage == null) ? "0" : tmsProducts[pp].discount_featured.discount_percentage,
              price_new: (tmsProducts[pp].discount_featured.price_new == null) ? "0.00" : tmsProducts[pp].discount_featured.price_new
            },
            // departure_months:(tmsProducts[pp].departure_months === null || tmsProducts[pp].departure_months === "" ) ? {[new Date().getFullYear()]:[]} : tmsProducts[pp].departure_months

            departure_months:{
              [new Date().getFullYear()]: (tmsProducts[pp].departure_months[new Date().getFullYear()] === null || tmsProducts[pp].departure_months[new Date().getFullYear()]  === "" || tmsProducts[pp].departure_months[new Date().getFullYear()]  === undefined ) ? [] : tmsProducts[pp].departure_months[new Date().getFullYear()],
              [new Date().getFullYear()+1]: (tmsProducts[pp].departure_months[new Date().getFullYear()+1] === null || tmsProducts[pp].departure_months[new Date().getFullYear()+1]  === "" || tmsProducts[pp].departure_months[new Date().getFullYear()+1]  === undefined ) ? [] : tmsProducts[pp].departure_months[new Date().getFullYear()+1]
            }

          }
          productResults[p].fields.productsTMS = tempObject2;
        }
      }

    }
    return productResults;
  }

export function sortedFilterResults(arr){

    // Check if 'sort' property exist
    // Check if 'popularity' property exist
    // Alphabetically sort and merge all
    let filteredSort = filter(arr, function(o){ return isInt(o.fields.sort) });
    let filteredPopularity = [];
    let filteredNotPopularity = [];
    let sortAlpha = [];
    let popularityAlpha = [];
    let notPopularityAlpha = [];
    let mergeSorted = [];

    if(filteredSort.length > 0){

      //filter popularity / none property
      filteredPopularity = filter(arr, function(o){ return o.fields.popularity === true && isInt(o.fields.sort) === false });
      filteredNotPopularity = filter(arr, function(o){ return (o.fields.popularity === false || o.fields.popularity === undefined) && isInt(o.fields.sort) === false });

      //alphabetically sort
      sortAlpha = orderBy(filteredSort, ['fields.sort']);
      popularityAlpha = orderBy(filteredPopularity,['fields.name'], ['asc']);
      notPopularityAlpha = orderBy(filteredNotPopularity,['fields.name'], ['asc']);

      //merge alpha sorted
      mergeSorted = unionBy(sortAlpha, popularityAlpha, notPopularityAlpha);
    }else{

      //filter popularity / none property
      filteredPopularity = filter(arr, function(o){ return o.fields.popularity === true});
      filteredNotPopularity = filter(arr, function(o){ return o.fields.popularity === false || o.fields.popularity === undefined });

      //alphabetically sort
      popularityAlpha = orderBy(filteredPopularity,['fields.name'], ['asc']);
      notPopularityAlpha = orderBy(filteredNotPopularity,['fields.name'], ['asc']);

      //merge alpha sorted
      mergeSorted = unionBy(popularityAlpha, notPopularityAlpha);
    }

    return mergeSorted;
  }

export function sortedPrice(arr, sortType){
  // Sort prices by ascending and descending order
  // Move products with no prices to the end of the array;
  const price = (sortType === 'low') ? ['asc'] : ['desc'];

  let pricesArray = [];
  let noPricesArray = [];
  let orderedPricesArray = [];

  pricesArray = filter(arr, function(o){ return o.fields.productsTMS.prices_from.adult_base_price !== 0 && o.fields.productsTMS.prices_from.adult !== "0.00" && o.fields.productsTMS.prices_from.adult_base_price !== undefined });
  noPricesArray = filter(arr, function(o){ return o.fields.productsTMS.prices_from.adult_base_price === 0 });
  noPricesArray = filter(arr, function(o){ return o.fields.productsTMS.prices_from.adult === "0.00" });
  orderedPricesArray = orderBy(pricesArray, ['fields.productsTMS.prices_from.adult_base_price'], price);

  return unionBy(orderedPricesArray, noPricesArray);
}

export function sortedDuration(arr, sortDuration){
  const duration = (sortDuration === 'short') ? ['asc'] : ['desc'];
  return orderBy(arr, ['fields.duration'], duration);
}

export function filterMonth(arr, selectMonth, year){

  //filter by months for only current year - pass array of months
  let monthArray = [];

  function containsAny(source,target){
      var result = source.filter(function(item){ return target.indexOf(item) > -1 });
      return (result.length > 0);
  }

  monthArray = filter(arr, (o) => {return containsAny(o.fields.productsTMS.departure_months[year], selectMonth)});

  return monthArray;
}

export function yearMonthFilter(arr, allMonths){

  let nextYear = new Date().getFullYear() + 1;
  let nextMonthNumber = [];
  let nextMonthArray = [];

  filter(arr, (o) => {
    if(o.fields.productsTMS.departure_months[nextYear].length > 0){
      nextMonthNumber.push(o.fields.productsTMS.departure_months[nextYear].length)
    }
  });

  for(let i = 0; i < Math.max.apply( Math, nextMonthNumber); i++){
    nextMonthArray.push(allMonths[i]);
  }

  return nextMonthArray;

}

export function allTripsFilterJSON(categoryArr, productResultsArr){

  let allTripsJSON = [];

  //array of names and categories
  for(let i = 0; i < categoryArr.length; i++){
    let categoryFilter = filter(productResultsArr, (o) => { return o.fields.category.fields.name === categoryArr[i].name });
    filter(categoryFilter, (o) => {
        allTripsJSON.push({
            name:o.fields.name,
            list_name:o.fields.name,
            category:o.fields.category.fields.name,
            weburl:o.fields.webUrl,
            tags:{startCity:o.fields.startCity.fields.name, endCity:o.fields.endCity.fields.name}
        })
    });
  }

  return allTripsJSON;
}

export function travelStylesJSON(travelStyleArr){

  //append travel style, category, weburl and name including count
  for(let i = 0; i < travelStyleArr.length; i++){
    travelStyleArr[i].weburl = "";
    travelStyleArr[i].list_name = travelStyleArr[i].name + " (" + travelStyleArr[i].count +")";
    travelStyleArr[i].category = "Travel Styles";
  }

  return travelStyleArr;
}

export function destinationFilterJSON(destinationsArr){

    //append destination category, weburl and name including count
    for(let i = 0; i < destinationsArr.length; i++){
        destinationsArr[i].weburl = "";
        destinationsArr[i].list_name = destinationsArr[i].name + " (" + destinationsArr[i].count +")";
        destinationsArr[i].category = 'Destination';
    }

    return destinationsArr;
}

export function countryFilterJSON(countriesArr){

  //append country category, weburl and name including count
  for(let i = 0; i < countriesArr.length; i++){
    countriesArr[i].weburl = "";
    countriesArr[i].list_name = countriesArr[i].name + " (" + countriesArr[i].count +")";
    countriesArr[i].category = 'Country';
  }

  return orderBy(countriesArr,['name'], ['asc']);
}

export function cyoaFilterJSON(popularArr){

  const cyoaArray = [];

  for(let i=0; i < popularArr.length; i++){
    if(i < 3){
      cyoaArray.push({
        "name":popularArr[i].fields.name,
        "list_name":popularArr[i].fields.name,
        "category":"Create your own adventure",
        "weburl":popularArr[i].fields.webUrl
      })
    }
  }
  return cyoaArray;
}



// WEBPACK FOOTER //
// ./src/helpers/filtershelper.js